exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".days-of-week-container {\n    display: flex;\n    margin-top: 4px;\n}\n.day-of-the-week {\n    pointer-events: none;\n    font-weight: 600;\n    width: 36px;\n    height: 36px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n", ""]);

// exports
